export default __webpack_public_path__ + "images/ve-b8bb0477d02228d82ffb54c74b24ec24.svg";